module.exports = __webpack_public_path__ + "static/1-c6597857e3e2ad38399fac07bc730e3e.png";